// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_DQ8","question":"styles_question__1T3du","inputVisibleButton":"styles_inputVisibleButton__2-zCk","note":"styles_note__3hXqR"};